import accountsContent from './content/accounts.json';

const accountsMock = {
    layoutType: 2,
    data: {
        name: 'accounts',
        layoutType: 2,
        areasList: [
            {
                id: 'accounts-page-area',
                name: 'Content',
                componentName: 'Comp:AccountsPage',
                content: JSON.stringify(accountsContent),
            },
        ],
    },
};

export default accountsMock;
